import { createIcon } from '../createIcon';

export const ChromecastIconConfig = {
  name: 'ChromecastIcon',
  height: 512,
  width: 512,
  svgPath: 'M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z',
  yOffset: 0,
  xOffset: 0,
};

export const ChromecastIcon = createIcon(ChromecastIconConfig);

export default ChromecastIcon;